if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.claimDealButton = this.querySelector('.product-form__claim-deal');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (evt.submitter == this.claimDealButton) {
        formData.append('quantity', this.claimDealButton.dataset.claimDealQty);
      }

      if (evt.submitter.classList.contains('product-form__shortfill-deal')) {
        function SendAPIRequest(url, method, params, customHeaders, cb) {
          var xhr = new XMLHttpRequest();

          xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
              if (cb) {
                var parsed;
                var ct = xhr.getResponseHeader( "Content-Type" );

                if ((ct) && (ct.indexOf("json") >= 0) && (xhr.responseText)) {
                  try {
                    parsed = JSON.parse( xhr.responseText );
                  }

                  catch (e) {
                    console.log( "error parsing JSON response : " + e.stack );
                  }
                }

                cb(xhr, parsed);
              } else {
                if (xhr.status == 200) {
                  window.location.reload();
                }
              }
            }
          };

          if (params) {
            xhr.open("POST", "/cart/add.js", true);
            xhr.setRequestHeader("Content-Type", "application/json");
            if (customHeaders && customHeaders.length) {
              AddCustomHeaders( xhr, customHeaders );
            }
            xhr.send(JSON.stringify(params));
          } else {
            console.log("Really Sending request to " + url);
            xhr.open("POST", "cart/add.js", true);
            if (customHeaders && customHeaders.length) {
              AddCustomHeaders(xhr, customHeaders);
            }
            xhr.send();
          }
        }

        var shortfillVariant  = evt.submitter.dataset.shortfillChild;
        var shortfillQuantity =  evt.submitter.dataset.shortfillDealQty;
        var multiplier = document.querySelector( ".product-form__quantity .quantity__input" ).value;
        shortfillQuantity = shortfillQuantity * multiplier;
        var body = { "id" : shortfillVariant, "quantity" : shortfillQuantity };
        var form = this;

        SendAPIRequest( "/cart/add.js", "POST", body, [], function( xhr ) {
          if (form.cart) {
            formData.append('sections', form.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            form.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                form.handleErrorMessage(response.description);

                const soldOutMessage = form.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                form.submitButton.setAttribute('aria-disabled', true);
                form.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                form.error = true;
                return;
              } else if (!form.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!form.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
              form.error = false;
              const quickAddModal = form.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { form.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                form.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              form.submitButton.classList.remove('loading');
              if (form.cart && form.cart.classList.contains('is-empty')) form.cart.classList.remove('is-empty');
              if (!form.error) form.submitButton.removeAttribute('aria-disabled');
              form.querySelector('.loading-overlay__spinner').classList.add('hidden');
              refreshProgressbar()
            });
        });
      } else {
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            refreshProgressbar()
          });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
